module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('icon', {
    staticStyle: {
      "color": "777"
    },
    attrs: {
      "name": _vm.iconName
    }
  }), _vm._v(" " + _vm._s(_vm.displayName) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88dea09c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalog/ColumnTreeItem.vue
// module id = 2145
// module chunks = 1